import React, { useMemo } from 'react'
import DropdownSelect from 'app/components/dropdown'
import IconButton from 'app/components/icon-button'
import { useTypedTranslation } from '../../hooks/use-translation'

type PageSelectProps = {
  page: number
  totalPages: number
  onChange: (page: number) => void
  mode?: 'standard' | 'compact'
}
export function PageSelect(props: PageSelectProps): JSX.Element {
  const { totalPages, onChange, page, mode = 'standard' } = props
  const { _t } = useTypedTranslation()
  const items = useMemo(() => {
    return Array.from({ length: totalPages }, (_, i) => ({ value: i + 1 }))
  }, [totalPages])

  return (
    <div className="page-select">
      {mode === 'standard' ? (
        <IconButton disabled={page === 1} onClick={() => onChange(1)} iconClass="ds3-icon ds3-chevron-left-double" />
      ) : null}

      <IconButton disabled={page === 1} onClick={() => onChange(page - 1)} iconClass="ds3-icon ds3-chevron-left" />

      <div className="all-pages">
        {mode === 'compact' ? (
          <span className="page-note-important px-2">
            {page}/{totalPages}
          </span>
        ) : (
          <>
            <DropdownSelect
              id="page-select"
              items={items}
              onClick={(page: string) => onChange(parseInt(page))}
              value={page + ''}
              asDiv
            />
            <span className="text-nowrap px-2">{_t('of-n-pages', { count: totalPages })}</span>
          </>
        )}
      </div>

      <IconButton
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        iconClass="ds3-icon ds3-chevron-right"
      />

      {mode === 'standard' ? (
        <IconButton
          disabled={page === totalPages}
          onClick={() => onChange(totalPages)}
          iconClass="ds3-icon ds3-chevron-right-double"
        />
      ) : null}
    </div>
  )
}
